/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { BakendHttpResponse } from '../../bakend-http-response';
import { RequestBuilder } from '../../request-builder';

import { BackendPatchedTaxSpecialRequestDto } from '../../models/backend-patched-tax-special-request-dto';
import { BackendTaxSpecialDto } from '../../models/backend-tax-special-dto';

export interface ProjectTaxesTaxSpecialPartialUpdate$FormData$Params {
  id: number;
  body?: BackendPatchedTaxSpecialRequestDto;
}

export function projectTaxesTaxSpecialPartialUpdate$FormData(
  http: HttpClient,
  rootUrl: string,
  params: ProjectTaxesTaxSpecialPartialUpdate$FormData$Params,
  context?: HttpContext,
): Observable<BakendHttpResponse<BackendTaxSpecialDto>> {
  const rb = new RequestBuilder(rootUrl, projectTaxesTaxSpecialPartialUpdate$FormData.PATH, 'patch');
  if (params) {
    rb.path('id', params.id, {});
    rb.body(params.body, 'multipart/form-data');
  }

  return http.request(rb.build({ responseType: 'json', accept: 'application/json', context })).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as BakendHttpResponse<BackendTaxSpecialDto>;
    }),
  );
}

projectTaxesTaxSpecialPartialUpdate$FormData.PATH = '/api/project_taxes/tax_special/{id}/';
